/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Modal, Form, Col, Row, Input, Button } from "antd";
import styles from "../styles/CobuyerCosellerList.module.css";
import { useDispatch, useSelector } from "react-redux";
import { contractStoreHandle } from "../../ContractStore/state/actions";
import PhoneInput from "react-phone-input-2";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import TextArea from "antd/lib/input/TextArea";
import { createOfferInitialState } from "../../Common/commondata/commonData";

const EditClientDetailsModal = ({ modalState, setModalState, rootDocData }) => {
  const { editClientDetailsModal, clientType, personId, uuidKey, corpSigner, labelType, editModalTitle, signerFieldsObj={} } = modalState || {};
  const { currentUrlId, contractAuthKey } = useSelector((state) => state.createOffer);
  const isReferallFormAgents = ["REFERRING_AGENT", "RECEIVING_AGENT"].includes(labelType) && rootDocData?.contractType === "BHHS_CP_RA";
  const [form2] = Form.useForm();
  const dispatch = useDispatch();
  const screens = useBreakpoint();
  const [isFormChanged, setIsFormChanged] = useState(false);

  const handleEditClientsModalCancel = () => {
    form2.resetFields();
    setModalState({...createOfferInitialState});
    setIsFormChanged(false);
  };

  useEffect(() => {
    try {
      const localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
      const clients = localData[clientType] || [];
      if (corpSigner) {
        const corpClient = clients.find((el) => el.key === uuidKey && el.isCorp);
        const signer = corpClient?.signers?.find((signer) => signer.personId === personId);
        if (corpClient && signer) {
          form2.setFieldsValue({
            corpfullName: corpClient.fullName || "",
            ...signer,
          });
        }
      } else {
        const personClient = clients.find((el) => el.personId === personId && !el.isCorp);
        if (personClient) {
          form2.setFieldsValue({ ...personClient });
        }
      }
    } catch (e) {
      console.error("Error setting fields in modal:", e);
    }
  }, [clientType, personId, uuidKey, currentUrlId]);

  const handleAddOrUpdate = () => {
    form2
      .validateFields()
      .then((values) => {
        values = { ...values };
        let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
        let clients = localData[clientType] || [];
        if (corpSigner) {
          const fullName = values.corpfullName;
          delete values.corpfullName;
          clients = clients.map((client) => {
            if (client.key === uuidKey && client.isCorp) {
              const updatedSigners =
                client.signers?.map((signer) => {
                  if (signer.personId === personId) {
                    return { ...signer, ...values };
                  }
                  return signer;
                }) || [];

              return {
                ...client,
                fullName: fullName || client.fullName,
                signers: updatedSigners,
              };
            }
            return client;
          });
        } else {
          clients = clients.map((client) => {
            if (!client.isCorp && client.personId === personId) {
              return { ...client, ...values };
            }
            return client;
          });
        }
        localData[clientType] = clients;
        localStorage.setItem(currentUrlId, JSON.stringify(localData));
        dispatch(contractStoreHandle.autoSaveContract({ currentUrlId, contractAuthKey, valueObj: { [clientType]: clients } }));
        handleEditClientsModalCancel();
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  return (
    <div>
      {editClientDetailsModal && (
        <Modal
          visible={editClientDetailsModal}
          width={"700px"}
          title={<div className="commonModalTitle">{editModalTitle || "Edit Contact Details"} </div>}
          onCancel={handleEditClientsModalCancel}
          footer={
            <>
              <Button onClick={handleEditClientsModalCancel}>Cancel</Button>
              <Button type="primary" onClick={handleAddOrUpdate} disabled={!isFormChanged}>
                {"Update"}
              </Button>
            </>
          }
          onOk={handleAddOrUpdate}
        >
          <div style={{ height: "45vh", padding: "0px 10px", overflow: "auto" }}>
            <div className={styles.formContainer}>
              <Form
                form={form2}
                layout="vertical"
                scrollToFirstError
                onValuesChange={() => {
                  setIsFormChanged(true);
                }}
              >
                {isReferallFormAgents && (
                  <>
                    <Row justify="space-between" gutter={[2, 2]}>
                      <Col span={screens.xs ? 24 : 11}>
                        <Form.Item className="lbl1" name="firmName" label="Company Name">
                          <Input type="text" allowClear placeholder="Enter Company Name" />
                        </Form.Item>
                      </Col>
                      <Col span={screens.xs ? 24 : 11}>
                        <Form.Item className="lbl1" name="address" label="Company Address">
                          <TextArea type="text" allowClear placeholder="Enter Company Address" />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row justify="space-between" gutter={[2, 2]}>
                      <Col span={screens.xs ? 24 : 11}>
                        <Form.Item className="lbl1" name="officePhoneNumber" label="Company Phone">
                          <PhoneInput allowClear inputStyle={{ width: "100%" }} inputClass="phoneInput" country={"us"} onlyCountries={["us"]} maxLength="10" international={false} disableCountryCode={true} placeholder="Enter Company Phone" className="phone-input" />
                        </Form.Item>
                      </Col>
                      <Col span={screens.xs ? 24 : 11}>
                        <Form.Item className="lbl1" name="faxNumber" label="Fax #">
                          <PhoneInput allowClear inputStyle={{ width: "100%" }} inputClass="phoneInput" country={"us"} onlyCountries={["us"]} maxLength="10" international={false} disableCountryCode={true} placeholder="Enter Fax Number" className="phone-input" />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row justify="space-between" gutter={[2, 2]} style={{ width: "100%" }}>
                      {corpSigner && (
                        <>
                          <Col span={screens.xs ? 24 : 11}>
                            <Form.Item className="lbl1" name="corpfullName" label="Corporation/Trust/Other Name" rules={[{ required: true, message: "Please enter Corporation/Trust Name!" }]}>
                              <Input type="text" allowClear placeholder="Enter Corporation/Trust Name" />
                            </Form.Item>
                          </Col>
                          <Col span={screens.xs ? 24 : 11}>
                            <Form.Item className="lbl1" name="title" label="Title">
                              <Input type="text" allowClear placeholder="Enter Title" />
                            </Form.Item>
                          </Col>
                        </>
                      )}
                    </Row>
                    <Row justify="space-between" gutter={[2, 2]}>
                      <Col span={screens.xs ? 24 : 11}>
                        <Form.Item className="lbl1" name="fullName" label="Agent Name" rules={[{ required: true, message: "Please enter Agent Name!" }]}>
                          <Input type="text" allowClear placeholder="Enter Agent Name" />
                        </Form.Item>
                      </Col>
                      <Col span={screens.xs ? 24 : 11}>
                        <Form.Item className="lbl1" name="phoneNumber" label="Agent Phone">
                          <PhoneInput allowClear inputStyle={{ width: "100%" }} inputClass="phoneInput" country={"us"} onlyCountries={["us"]} maxLength="10" international={false} disableCountryCode={true} placeholder="Enter Agent Phone" className="phone-input" />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row justify="start" gutter={[2, 2]}>
                      <Col span={screens.xs ? 24 : 11}>
                        <Form.Item className="lbl1" name="email" label="Agent Email" rules={[{ type: "email", message: "Not a valid Email!" }, { required: true, message: "Please enter Email!" }, { whitespace: true }]}>
                          <Input type="text" allowClear placeholder="Enter Agent Email" />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}
                {!isReferallFormAgents && (
                  <>
                     <Row justify="space-between" gutter={[2, 2]} style={{ width: "100%" }}>
                      {corpSigner && (
                        <>
                          <Col span={screens.xs ? 24 : 11}>
                            <Form.Item className="lbl1" name="corpfullName" label="Corporation/Trust/Other Name" rules={[{ required: true, message: "Please enter Corporation/Trust Name!" }]}>
                              <Input type="text" allowClear placeholder="Enter Corporation/Trust Name" />
                            </Form.Item>
                          </Col>
                          <Col span={screens.xs ? 24 : 11}>
                            <Form.Item className="lbl1" name="title" label="Title">
                              <Input type="text" allowClear placeholder="Enter Title" />
                            </Form.Item>
                          </Col>
                        </>
                      )}
                    </Row>
                    <Row justify="space-between" gutter={[2, 2]}>
                      <Col span={screens.xs ? 24 : 11}>
                        <Form.Item className="lbl1" name="fullName" label="Contact Name" rules={[{ required: true, message: "Please enter Contact Name!" }]}>
                          <Input type="text" allowClear placeholder="Enter Contact Name" />
                        </Form.Item>
                      </Col>
                      <Col span={screens.xs ? 24 : 11}>
                        <Form.Item className="lbl1" name="email" label="Email Address" rules={[{ type: "email", message: "Not a valid Email!" }, { required: true, message: "Please enter Email!" }, { whitespace: true }]}>
                          <Input type="text" allowClear placeholder="Enter Email" />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row justify="space-between" gutter={[2, 2]}>
                      <Col span={screens.xs ? 24 : 11}>
                        <Form.Item className="lbl1" name="phoneNumber" label="Phone No.">
                          <PhoneInput allowClear inputStyle={{ width: "100%" }} inputClass="phoneInput" country={"us"} onlyCountries={["us"]} maxLength="10" international={false} disableCountryCode={true} placeholder="Enter Phone Number" className="phone-input" />
                        </Form.Item>
                      </Col>
                      <Col span={screens.xs ? 24 : 11}>
                        <Form.Item className="lbl1" name="faxNumber" label="Fax No.">
                          <PhoneInput allowClear inputStyle={{ width: "100%" }} inputClass="phoneInput" country={"us"} onlyCountries={["us"]} maxLength="10" international={false} disableCountryCode={true} placeholder="Enter Fax Number" className="phone-input" />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row justify="space-between" gutter={[2, 2]}>
                      <Col span={screens.xs ? 24 : 24}>
                        <Form.Item className="lbl1" name="address" label={signerFieldsObj?.addressLabel || "Address"}>
                          <TextArea type="text" allowClear placeholder="Enter Address" />
                        </Form.Item>
                      </Col>
                    </Row>
                    {signerFieldsObj?.personalAddress &&  <Row justify="space-between" gutter={[2, 2]}>
                      <Col span={screens.xs ? 24 : 24}>
                        <Form.Item className="lbl1" name="personalAddress" label={signerFieldsObj?.personalAddressLabel || "Personal Address"}>
                          <TextArea type="text" allowClear placeholder="Enter Address" />
                        </Form.Item>
                      </Col>
                    </Row>}
                  </>
                )}
              </Form>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default EditClientDetailsModal;
